import {
  animate,
  query,
  stagger, style, transition, trigger
} from "@angular/animations";
import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Module } from '@core/configs/role';
import { RoleService } from '__services';
import { LodashUtil } from '__utils';
import * as moment from 'moment';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger("pageAnimations", [
      transition(":enter", [
        query(".main-widget, .top, .heading, .user-tips", [
          style({ opacity: 0, transform: "translateY(300px)" }),
          stagger(-50, [
            animate(
              "500ms cubic-bezier(0.35, 0, 0.25, 1)",
              style({ opacity: 1, transform: "none" })
            )
          ])
        ])
      ]),
      // transition(":leave", [
      //   query(".main-widget, .top, .heading, .user-tips", [
      //     stagger(-50, [
      //       animate("300ms ease-out", style({ opacity: 0, width: "0px" }))
      //     ])
      //   ])
      // ])
    ])
  ]
})
export class DashboardComponent implements OnInit {
  @HostBinding("@pageAnimations")
  alertModule = {
    class: 'alerts',
    title: 'Validation',
    des: 'Records that actions are needed by logged user.',
    link: '/alerts/alerts-notification',
    access: true
  };
  modules: any = [
    {
      class: 'requests',
      title: 'Requests',
      des: 'Allows user to send request to other personas.',
      link: '/requests',
      module_id: Module.REQUEST
    },
    {
      class: 'transport',
      title: 'Active Jobs',
      des: 'Transport records of a company.',
      link: '/physical-transport',
      module_id: Module.PHYSICAL_TRANSPORT
    },
    {
      class: 'intermodal',
      title: 'Site Operations',
      des: 'Action tasks on company production plants.',
      link: '/intermodal',
      module_id: Module.INTERMODAL
    },
    {
      class: 'compliance',
      title: 'Job Management',
      des: 'Management of flow of a journey.',
      link: '/compliance',
      module_id: Module.COMPLIANCE
    },
    {
      class: 'admin',
      title: 'Admin',
      des: 'Management of Company info and User records.',
      link: '/admin',
      module_id: Module.ADMIN
    },
    {
      class: 'admin',
      title: 'LogChain Admin',
      des: 'Management of platform records.',
      link: '/logchain-admin',
      module_id: Module.LOGCHAIN
    }
  ];
  expandTools = false;
  currentDate = '';

  constructor(
    private roleService: RoleService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.roleService.getMenus();
    const modules = LodashUtil.cloneDeep(this.roleService.module);
    this.modules = LodashUtil.sortBy(modules, 'order'); 
    this.getToday();
  }

  onGo(module, index) {
    this.roleService.onNavToModule(module, this.activatedRoute.routeConfig.path, index);
  }

  getToday(): void {
    let lang = localStorage.getItem('userLang') || 'en';
    if(lang === 'zh') {
      lang = 'zh-cn';
    };
    moment.locale(lang);
    this.currentDate =moment().format('dddd Do MMMM YYYY');
  }
}
